export const RECEIVE_SERVER_RESPONSE = "receive_server_response";
export const RECEIVE_WARROOMSERVER_RESPONSE = "receive_warroomserver_response";
export const RECEIVE_CODEXLBSERVER_RESPONSE = "receive_codexlbserver_response";
export const LOAD_USERDATA = "load_userdata";
export const CHANGE_PAGE = "change_page";
export const PAGE_SELECTED = "page_selected";
export const BRAND_SELECTED = "brand_selected";
export const BRANCH_SELECTED = "branch_selected";
export const LOGOUT = "logout";
export const ALERT = "alert";
export const CLEAR_NAV_HISTORY = "clear_nav_history";
export const STEP_BACK = "step_back";
export const UPDATE_GLOBAL_SEARCH = "update_global_search";
export const LOAD_ACCOUNTS = "load_accounts";
export const RELOAD_BRANDS = "reload_brands";
export const SET_ACTIVE_ACCOUNT_ID = "set_active_account_id";
export const LOAD_PLAN_DATA = "load_plan_data";
export const LOAD_PLAN_OVERRIDES = "load_plan_overrides";